export default {
    methods: {
        removeBus () {
            this.$storage.removeUniversal('busConfirmInfo');
        },
        removeDomestic () {
            this.$storage.removeUniversal('domesticConfirmInfo');
        },
        removeInternational () {
            this.$storage.removeUniversal('internationalConfirmInfo');
        },
        removeTrain () {
            this.$storage.removeUniversal('trainConfirmInfo');
        },
        _removeQueryString () {
            this.$storage.removeUniversal('queryString');
        },
        _removeAllStorages () {
            this.removeBus();
            this.removeDomestic();
            this.removeInternational();
            this.removeTrain();
            this._removeQueryString();
        },
    },
};
